module.exports = __webpack_public_path__ + "static/media/loire-workshop-poster.1c32d10b.jpeg";